<!-- eslint-disable -->
<template lang="pug">
    course-form(v-if="course && !isLoading" :course="course" :submit="update")
        template(slot="title") {{ $i18n.t('course.course_edit_title') }}
        template(slot="button") {{ $i18n.t('course.course_edit_button') }}
    cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import CourseForm from './Form.vue';
    import CourseApi from '../../api/course';
    import {mapState} from 'vuex';

    import getGameName from '../../utils/trainer/trainer'

    export default {
        data() {
            return {
                course: null,
                isLoading: false
            }
        },
        mixins: [getGameName],
        props: ['id'],
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                if (this.isNotAccess) {
                    this.$router.push({name: '403'});
                    return;
                }
                this.isLoading = true;
                CourseApi.show(this.id)
                    .then((data) => {
                        this.course = data;
                        this.course.games.forEach(item => item.name = this.getGameName(item));
                        this.isLoading = false;
                    })
            },
            update(course) {
                return CourseApi.update(this.id, course)
                    .then((data) => {
                        this.$router.push({name: 'course:profile', params: {id: data.id}});
                    })
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isNotAccess () {
                return !this.user.isSuperadmin && !this.user.isManagerOrSupport;
            },
        },
        components: {
            CourseForm
        },
        beforeRouteLeave (to, from, next) {
            if (!['create:game', 'games:settings'].includes(to.name)) {
                this.$store.dispatch('setHomework', null);
                this.$store.dispatch('setPuzzleGame', null);
            }
            next();
        }
    }
</script>
